import { useState } from "react";
import { useSiteImage } from "@/context/SiteImages";

export const PlaceholderImage = ({ label = "[CTS PHOTO]", className = "", testId }) => (
  <div
    data-testid={testId}
    className={`relative flex items-center justify-center overflow-hidden bg-cts-soft border border-dashed border-cts-inputline rounded-lg ${className}`}
    role="img"
    aria-label={label}
  >
    <svg className="absolute inset-0 w-full h-full opacity-[0.07]" viewBox="0 0 200 200" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <path d="M100 20 a80 80 0 1 0 0.01 0" fill="none" stroke="#F20D18" strokeWidth="18" strokeDasharray="380 140" />
      <rect x="118" y="40" width="14" height="120" fill="#313A40" />
    </svg>
    <span className="relative font-heading font-bold uppercase tracking-widest text-cts-charcoal/50 text-xs px-4 text-center">
      {label}
    </span>
  </div>
);

export const BrandImage = ({ src, imgKey, alt, className = "", label = "[CTS PHOTO]", eager = false, testId }) => {
  const resolvedSrc = useSiteImage(imgKey, src);
  const [error, setError] = useState(false);
  if (!resolvedSrc || error) return <PlaceholderImage label={label} className={className} testId={testId} />;
  return (
    <img
      key={resolvedSrc}
      src={resolvedSrc}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      data-testid={testId}
      onError={() => setError(true)}
      className={`object-cover ${className}`}
    />
  );
};
